module.exports = __webpack_public_path__ + "assets/public/imgs/network-policy-samples/7-web-allow-production.svg";